// Cross-platform success / error toast helper.
// On Android: ToastAndroid; on iOS: transient Alert. Centralised so the
// `react-native/split-platform-components` ESLint rule can be silenced in
// exactly one place rather than per-screen.

import { Platform, Alert, ToastAndroid } from "react-native"; // eslint-disable-line react-native/split-platform-components

export const notifySuccess = (msg) => {
  if (!msg) return;
  if (Platform.OS === "android") {
    ToastAndroid.show(String(msg), ToastAndroid.SHORT);
  } else {
    Alert.alert("", String(msg));
  }
};

// `iosTitle`: PartnerRoutingAndPacking titles its iOS alert "Error"; the
// dark store screens show the message alone (pass "").
export const notifyError = (msg, iosTitle = "Error") => {
  if (!msg) return;
  if (Platform.OS === "android") {
    ToastAndroid.show(String(msg), ToastAndroid.LONG);
  } else {
    Alert.alert(iosTitle, String(msg));
  }
};

export const notifyInfo = (msg) => {
  if (!msg) return;
  if (Platform.OS === "android") {
    ToastAndroid.show(String(msg), ToastAndroid.SHORT);
  } else {
    Alert.alert("", String(msg));
  }
};
